var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadMore"},[(_vm.finished)?_c('span',[_vm._v("暂无更多")]):_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.load}},[_vm._v("加载更多")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }